import type { WorkflowRole } from './types';

/**
 * Classify a workflow participation code into a WorkflowRole.
 *
 * Input is the raw string stored in intel_core_workflow_people.user_workflow_role:
 *   '1' -> lead        (workflow lead)
 *   '2' -> support_1   (primary support)
 *   '3' -> support_2   (secondary support)
 *   anything else -> other
 *
 * Null, undefined, empty, non-matching, and whitespace-padded unknowns all
 * return 'other'. Trimming ensures padded codes from BigQuery normalise.
 */
export function classifyWorkflowRole(code: string | null | undefined): WorkflowRole {
  if (code === null || code === undefined) return 'other';
  const trimmed = code.trim();
  switch (trimmed) {
    case '1':
      return 'lead';
    case '2':
      return 'support_1';
    case '3':
      return 'support_2';
    default:
      return 'other';
  }
}
